import { EmploymentStatusEnum, HowEmployedEnum, TypeOfSelfEmploymentEnum } from './types';

export const employmentQuestions: Record<string, any> = {
  employmentStatus: {
    labelKey: 'applicationForm.EMPLOYMENT.employmentStatus.label',
    options: [
      { labelKey: 'applicationForm.EMPLOYMENT.employmentStatus.employee', value: EmploymentStatusEnum.EMPLOYEE },
      {
        labelKey: 'applicationForm.EMPLOYMENT.employmentStatus.selfEmployed',
        value: EmploymentStatusEnum.SELF_EMPLOYED,
      },
      { labelKey: 'applicationForm.EMPLOYMENT.employmentStatus.unemployed', value: EmploymentStatusEnum.UNEMPLOYED },
      { labelKey: 'applicationForm.EMPLOYMENT.employmentStatus.retired', value: EmploymentStatusEnum.RETIRED },
    ],
  },
  howEmployed: {
    labelKey: 'applicationForm.EMPLOYMENT.howEmployed.label',
    note: 'applicationForm.EMPLOYMENT.howEmployed.note',
    options: [
      { labelKey: 'applicationForm.EMPLOYMENT.howEmployed.permanent', value: HowEmployedEnum.PERMANENT },
      { labelKey: 'applicationForm.EMPLOYMENT.howEmployed.contractor', value: HowEmployedEnum.CONTRACTOR },
    ],
  },
  zeroHoursContract: {
    labelKey: 'applicationForm.EMPLOYMENT.zeroHoursContract.label',
    options: [
      { labelKey: 'applicationForm.EMPLOYMENT.zeroHoursContract.yes', value: 'yes' },
      { labelKey: 'applicationForm.EMPLOYMENT.zeroHoursContract.no', value: 'no' },
    ],
  },
  typeOfSelfEmployment: {
    labelKey: 'applicationForm.EMPLOYMENT.typeOfSelfEmployment.label',
    options: [
      {
        labelKey: 'applicationForm.EMPLOYMENT.typeOfSelfEmployment.limitedCompanyGreater',
        value: TypeOfSelfEmploymentEnum.LIMITED_COMPANY_GREATER,
      },
      {
        labelKey: 'applicationForm.EMPLOYMENT.typeOfSelfEmployment.limitedCompanyBelow',
        value: TypeOfSelfEmploymentEnum.LIMITED_COMPANY_BELOW,
      },
      {
        labelKey: 'applicationForm.EMPLOYMENT.typeOfSelfEmployment.soleTrader',
        value: TypeOfSelfEmploymentEnum.SOLE_TRADER,
      },
      {
        labelKey: 'applicationForm.EMPLOYMENT.typeOfSelfEmployment.partnership',
        value: TypeOfSelfEmploymentEnum.PARTNERSHIP,
      },
    ],
  },
};
